import { Layout } from "antd";
import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import PageNotFound from "./pages/404";
import Home from "./pages/home";

const { Header, Content, Footer } = Layout;

const App = () => {
  return (
    <BrowserRouter>
      <Layout>
        <Header style={{ background: "#fff" }}>
          <img src="/autosled-logo.png" alt="Autosled" style={{ width: 50 }} />
        </Header>
        <Content className="content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>

          <Footer style={{ textAlign: "center" }}>
            Copyright ©2025 Autosled
          </Footer>
        </Content>
      </Layout>
    </BrowserRouter>
  );
};

export default App;
